export const emailContent = {
  branding: {
    companyName: "Streamoid OS",
  },
  hero: {
    title: "Your retail command center",
    subtitle:
      "Intelligent agents and tools for every brand function, from concept to commerce.",
  },
  otp: {
    title: "Enter the Verification Code",
    subtitle: "We have sent a unique verification code to <at mail.com>.",
    codeLabel: "Verification Code",
    codePlaceholder: "XXXXXX",
    buttonText: "Continue",
    resendText: "Didn't receive the code?",
    resendLink: "Resend",
    errorText: "Invalid code! Try again or",
    termsText:
      "By continuing, you agree to Streamoid OS's Terms of Service and acknowledge the Privacy Policy.",
  },

  email: {
    title: "Enter Email",
    subtitle: "We have sent a unique verification code to <at mail.com>.",
    codeLabel: "Verification Code",
    codePlaceholder: "XXXXXX",
    buttonText: "Continue",
    resendText: "Didn't receive the code?",
    resendLink: "Resend",
    errorText: "Invalid email!",
    termsText:
      "By continuing, you agree to Streamoid OS's Terms of Service and acknowledge the Privacy Policy.",
  },
  images: {
    backgroundImage: "figma:asset/35f15a664f2ccddff9bb6ee1fca7adc35be4677b.png",
  },
};

export const setupSteps = [
  "Creating profile",
  "Setting up workspaces",
  "Provisioning resources",
  "Starting agents",
];
export default emailContent;
